import { atom } from "recoil"
import { PaymentMethod, Project } from "@microtica/ms-project-sdk";

export const projectsState = atom({
    key: "ProjectsState",
    default: [] as Project[]
});

export const currentProjectState = atom({
    key: "CurrentProjectState",
    default: JSON.parse(localStorage.getItem("project") || "{}") as Project & { subscription?: any; paymentMethods?: PaymentMethod[] }
});